import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
@Injectable()
export class DropDownService {
  subject$ = new Subject();
  constructor() { }
  observeData(str) {
    this.subject$.next(str)
  }
}
